import { dropdownTriggerClassname } from "app/components/Dropdown";
import MemberProfileAvatar from "app/components/MemberProfileAvatar";
import CustomTooltip from "app/components/Tooltip";
import MemberSelection from "app/containers/Features/components/MemberSelection";
import { filterActiveTeamMembers } from "app/containers/Features/components/MemberSelection/helper";
import { selectProjectMemberList } from "app/containers/Features/components/MemberSelection/redux/selector";
import { IMemberList } from "app/containers/Features/components/MemberSelection/types";
import clsx from "clsx";
import { UserIcon } from "lucide-react";
import React from "react";
import { useSelector } from "react-redux";

interface AssigneeSelectionProps {
  assignedTo: string;
  onUpdate: (id: string) => void;
}

const Assignee: React.FC<AssigneeSelectionProps> = ({
  assignedTo,
  onUpdate,
}) => {
  const members = useSelector(selectProjectMemberList);
  const activeTeamMembers = filterActiveTeamMembers(members);

  const updateValue = (data: IMemberList) => {
    // update form out side parent component
    onUpdate?.(data._id);
  };

  return (
    <div className=" relative w-full ">
      <MemberSelection
        trigger={
          <button
            className={clsx(
              "flex items-center justify-between w-full p-[6px]  ",
              dropdownTriggerClassname,
            )}
          >
            <CustomTooltip
              text="Set assignee"
              className="flex items-center gap-1   "
              position="left"
            >
              <div className="flex items-center gap-1 ">
                <UserIcon size={16} color="#79808A" />
                {assignedTo && (
                  <MemberProfileAvatar
                    id={assignedTo}
                    circleClassName="!size-4"
                    initialsClassName=" !text-[8px]"
                  />
                )}
              </div>
            </CustomTooltip>
          </button>
        }
        align="center"
        selectedValue={assignedTo}
        updateValue={updateValue}
        options={activeTeamMembers}
        headingText="Assignees"
      />
    </div>
  );
};

export default Assignee;
